// **NOTE** Do not edit version and buildType below. Use version.sh and call ./build.sh updateDependencies QA/PROD
// instead.
/** @internal */ export var SDK_VERSION = "2.0.1";
/** @internal */ export var BUILD_TYPE = "DEV";
